interface ComingSoonProps {
  title: string;
  phase: string;
  description: string;
}

/** Placeholder shown on routes that have a shell but no feature yet. */
export function ComingSoon({ title, phase, description }: ComingSoonProps) {
  return (
    <div className="p-8 max-w-2xl mx-auto">
      <div className="bg-bg1 border border-border rounded-lg p-6 shadow-card">
        <div className="flex items-center gap-2 mb-3">
          <h2 className="text-xl font-bold text-fg">{title}</h2>
          <span className="text-[10px] font-mono uppercase tracking-widest text-teal bg-teal/10 border border-teal/30 rounded px-1.5 py-0.5">
            {phase}
          </span>
        </div>
        <p className="text-sm text-fg-muted leading-relaxed">{description}</p>
      </div>
    </div>
  );
}
